<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-layout v-for="col in getDialogKeys" :key="col.value">
          <v-flex>
            <v-textarea v-if="col.value === 'products'" :label="col.text"
                        v-model="itemDetail[col.value]"/>
            <v-autocomplete v-else-if="col.value === 'city'"
                            :color="Theme.GREEN"
                :items="cityList"
                placeholder="縣市"
                v-model="itemDetail[col.value]"
            ></v-autocomplete>
            <v-autocomplete v-else-if="col.value === 'street'"
                            :color="Theme.GREEN"
                            :items="areaList[itemDetail.city] ? areaList[itemDetail.city] : []"
                            placeholder="鄉鎮區"
                            :disabled="!itemDetail.city || itemDetail.city === ''"
                            v-model="itemDetail[col.value]"
            ></v-autocomplete>
            <v-select v-else-if="col.options"
                      :color="Theme.GREEN"
                      :items="col.options"
                      :label="col.text"
                      item-text="text" item-value="key"
                      v-model="itemDetail[col.value]"/>
            <v-text-field v-else v-model="itemDetail[col.value]"
                          :label="col.text"
                          :color="Theme.GREEN"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

const cityData = require('@/assets/json/taiwan_city.json');
export default {
  name: "store_detail",
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      cityData,
      cityList: [],
      areaList: {},
      saveLoading: false,
    };
  },
  created() {
    this.cityData.taiwan.forEach((city) => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });
  },
  computed: {
    getDialogKeys() {
      return [
        {value: 'name', text: '門市名稱'},
        {value: 'cellphone', text: '門市電話'},
        {value: 'time', text: '營業時間'},
        {value: 'city', text: '縣市'},
        {value: 'street', text: '鄉鎮區'},
        {value: 'address', text: '地址'},
        {value: 'latitude', text: '緯度'},
        {value: 'longitude', text: '經度'},
        {
          value: 'target', text: '顯示', options: this.getStoreTargetList
        },
        {
          value: 'storeType', text: '類型', options: this.getStoreTypeList
        },
        {value: 'products', text: '商品'},
      ];
    },
  },
  methods: {
    ...mapActions(['saveStoreInfo']),
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveStoreInfo({token: '', info: this.itemDetail});
      const result = res.data;
      if (result.code === 0) {
        this.$emit('confirmEvent', this.itemDetail);
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
      this.saveLoading = false;

    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
